import script from "./BannerManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerManagement.vue?vue&type=script&setup=true&lang=js"

import "./BannerManagement.vue?vue&type=style&index=0&id=c6ef3f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6ef3f48"]])

export default __exports__